import { ChatRoomLastMessageInfo } from '@dinosband/bv-messenger-schema'
import { queryLastMessages } from '@dinosband/bv-messenger-client'

import { DataCenter_ProxyType } from '../abstract'

export class LastCommentMessages extends DataCenter_ProxyType<number, ChatRoomLastMessageInfo> { //number is chatRoomId

  async init () {
    //
  }

  async readMany (chatRoomIds: number[], update: boolean) {
    if (!update) {
      chatRoomIds = chatRoomIds.filter((i) => !this.has(i))
    }
    if (!chatRoomIds.length) {
      return []
    }
    const result = await queryLastMessages(await this.context.messengerClient.getClient(), chatRoomIds, false)
    result?.forEach((i) => this.set(i.chatRoomId, i))
    return chatRoomIds.flatMap((i) => this.get(i) ?? [])
  }

}
